<template>
    <div v-if="params.value">{{ params.data.userData.firstName }} {{ params.data.userData.lastName }}</div>
</template>

<script>
export default {
  name: 'CellRendererName'
}
</script>
